// extracted by mini-css-extract-plugin
module.exports = {"base":"EngCalorificValueCalculator-module-base","topLabel":"EngCalorificValueCalculator-module-top-label","infoIcon":"EngCalorificValueCalculator-module-info-icon"};